import { render, staticRenderFns } from "./LogoutLink.vue?vue&type=template&id=351a2012"
import script from "./LogoutLink.vue?vue&type=script&lang=js"
export * from "./LogoutLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports